<template>
  <base-side-page
    @cancel="cancelSidePage"
    :title="$t('bill.text_73')"
    icon="res-billresourcetype"
    :res-name="getResName(detailData.resource_type)"
    :current-tab="params.windowData.currentTab"
    :loaded="loaded"
    :tabs="detailTabs"
    @tab-change="handleTabChange">
    <component
      :is="params.windowData.currentTab"
      :res-id="data.id"
      :id="listId"
      :data="detailData"
      :on-manager="onManager"
      :show-group-actions="false"
      :show-single-actions="false"
      :getParams="getParams"
      :hiddenKindTabs="hiddenKindTabs"
      :defaultResourceType="defaultResourceType"
      :defaultDate="date.dateParam"
      :defaultDateMode="date.dateMode"
      :defaultDataType="date.dateParam.data_type"
      :showBillShared="true"
      @tab-change="handleTabChange" />
  </base-side-page>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import Overview from '@Bill/views/overview/components'
import Actions from '@/components/PageList/Actions'
import SidePageMixin from '@/mixins/sidePage'
import WindowsMixin from '@/mixins/windows'
import { getBillResourceTypeLabel } from '@Bill/utils'
import ColumnsMixin from '../mixins/columns'

export default {
  name: 'BillResourcetypeSidePage',
  components: {
    Actions,
    Overview,
  },
  mixins: [SidePageMixin, WindowsMixin, ColumnsMixin],
  data () {
    return {
      detailTabs: [
        { label: this.$t('bill.budget_alert_type_cost'), key: 'overview' },
      ],
    }
  },
  computed: {
    ...mapGetters(['isDomainMode', 'scope']),
    listId () {
      switch (this.params.windowData.currentTab) {
        case 'overview':
          return 'OverviewForBillResourceTypeSidePage'
        default:
          return ''
      }
    },
    getParams () {
      return {}
    },
    defaultResourceType () {
      return this.listRowData.resource_type
    },
    hiddenKindTabs () {
      if (this.isDomainMode) {
        return ['domain', 'resource-type', 'external_project']
      } else if (this.isProjectMode) {
        return ['domain', 'project', 'resource-type', 'external_project']
      }
      return ['resource-type', 'external_project']
    },
    date () {
      const dateParam = _.get(this.params, 'options.dateParam') || {}
      const dateMode = _.get(this.params, 'options.dateMode') || ''
      return { dateParam, dateMode }
    },
  },
  methods: {
    getResName (name) {
      return getBillResourceTypeLabel(name)
    },
  },
}
</script>
